import React from 'react';
import PropTypes from 'prop-types';
import Steps from './Steps';
import ImageDescription from './ImageDescription';

const RightSection = ({ tutorialSteps }) => (
  <div className='tutorial-item tutorial-item--right'>
    {tutorialSteps.map((step, index, arr) => {
      return (
        <div className='tutorial-step' key={index}>
          <Steps arr={arr} index={index} />
          <ImageDescription step={step} />
        </div>
      );
    })}
  </div>
);

RightSection.propTypes = {
  tutorialSteps: PropTypes.array,
};

export default RightSection;
